"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orcasSharedDataMock = void 0;
const index_1 = require("../../index");
const carrier_1 = require("./carrier");
const userCompany_1 = require("./userCompany");
const contact_1 = require("./contact");
const user_1 = require("./user");
const orcasSharedDataMock = (sharedData) => ({
    type: index_1.SharedDataType.ORCAS,
    cpsCarrier: (0, carrier_1.cpsCarrierMock)(),
    company: (0, userCompany_1.userCompanyMock)(),
    contact: (0, contact_1.userContactMock)(),
    user: (0, user_1.userMock)(),
    hasMarketplaceAccess: false,
    hasOnboardingFormAccess: true,
    language: 'en',
    tenant: index_1.Tenant.SENNDER,
    featureFlags: {},
    profile: user_1.carrierProfileMock,
    ...sharedData
});
exports.orcasSharedDataMock = orcasSharedDataMock;
